import { Box, Skeleton } from 'hephaestus/web';
import type { FC, ReactNode } from 'react';

export type TradeFlowPipelineSkeletonProps = {
  stageCount: number;
  header: ReactNode;
};

export const TradeFlowPipelineSkeleton: FC<TradeFlowPipelineSkeletonProps> = ({
  stageCount,
  header,
}) => {
  const count = stageCount || 4;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      {header}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: `repeat(${count}, 1fr)`,
          gap: 1,
        }}
      >
        {Array.from({ length: count }, (_, i) => (
          <Skeleton key={i} variant='rounded' height={108} />
        ))}
      </Box>
    </Box>
  );
};
